<template>
  <div>
    <div class="loader" v-if="this.isLoading"></div>
    <div class="loadertext" v-if="this.isLoading">
      {{ $t("loadingTxt") }}...
    </div>
    <div class="main-wrapper" :class="{ 'blur-content': this.isLoading }">
      <!--begin::sidebar-->
      <sidebar-component classMenu="DashboardFullfilment"></sidebar-component>
      <!--end::sidebar-->

      <div class="page-wrapper">
        <!--begin::navbar-->
        <navbar-component></navbar-component>
        <!--end::navbar-->
        <!--begin::content-->
        <div class="page-content">
          <div
            class="d-flex justify-content-between align-items-center flex-wrap grid-margin"
          >
            <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
              <div class="card">
                <div class="card-header">
                  &nbsp;&nbsp;&nbsp;
                  <h6
                    class="card-title mb-0 float-start"
                    style="padding-left: 25px"
                  >
                    {{ $t("create_proforma_invoice") }}
                  </h6>
                  <button
                    v-show="type == 'edit'"
                    class="btn btn-twitter btn-sm float-end"
                    @click="recalculate"
                    type="button"
                  >
                    <i class="link-icon" data-feather="refresh-cw"></i>
                    {{ $t("recalculatePi") }}
                  </button>
                </div>
                <div class="card-body">
                  <!--begin::loading-data-->
                  <div v-if="isLoading" class="d-flex align-items-center">
                    <div
                      class="spinner-border ms-auto"
                      role="status"
                      aria-hidden="true"
                    ></div>
                    <strong>{{ $t("loadingTxt") }}...</strong>
                  </div>
                  <div
                    class="d-flex justify-content-between align-items-baseline mb-2"
                  ></div>

                  <div class="row mb-3" v-if="forms.pi_number">
                    <div class="col-lg-2">
                      <label
                        for="proforma_invoice_number"
                        class="col-form-label"
                        style="padding-left: 25px"
                        >{{ $t("piNumber") }}</label
                      >
                    </div>
                    <div class="col-lg-4">
                      <input
                        type="text"
                        class="form-control"
                        id="proforma_invoice_number"
                        :placeholder="this.$t('piNumber')"
                        :value="forms?.pi_number"
                        disabled
                      />
                      <div v-if="errors.pi_number">
                        <div
                          v-for="error in errors.pi_number"
                          :key="error"
                          class="alert alert-primary"
                          role="alert"
                        >
                          <i data-feather="alert-circle"></i>
                          {{ error }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-lg-2">
                      <label class="col-form-label" style="padding-left: 25px"
                        >Company</label
                      >
                    </div>
                    <div class="col-lg-4">
                      <!-- <input
                        type="text"
                        class="form-control"
                        :placeholder="'Total Load Id'"
                        v-model="company"
                        :disabled="type == 'edit' ? true : false"
                      /> -->
                      <multiselect
                          @search-change="asyncSearchCompany"
                          v-model="company"
                          :options="fetchCompany"
                          label="name"
                          :searchable="true"
                          track-by="name"
                          @open="removeReadonly"
                          ref="inputCompany"
                          placeholder="Please Select Company"
                          :disabled="type == 'edit' || rows.length > 0"
                          @input="selectedCompany"
                          :custom-label="company_label"
                        >
                          <span slot="noResult">-</span>
                        </multiselect>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-lg-2">
                      <label class="col-form-label" style="padding-left: 25px"
                        >Enteries / Load Id</label
                      >
                    </div>
                    <div class="col-lg-4">
                      <input
                        type="text"
                        class="form-control"
                        :placeholder="'Total Load Id'"
                        :value="totalLoad"
                        disabled
                      />
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-lg-2">
                      <label
                        for="proforma_invoice_number"
                        class="col-form-label"
                        style="padding-left: 25px"
                        >TOTAL</label
                      >
                    </div>
                    <div class="col-lg-4">
                      <input
                        type="text"
                        class="form-control"
                        :placeholder="'TOTAL'"
                        :value="formatCurrency(totals)"
                        disabled
                      />
                    </div>
                  </div>
                  <!--end::loading-data-->
                  <div class="row">
                    <div class="col-lg-12">
                      <!-- @on-selected-rows-change="selectionChanged" 
                                                @on-page-change="onPageChange"
                                                @on-sort-change="onSortChange"
                                                @on-column-filter="onColumnFilter"
                                                @on-per-page-change="onPerPageChange" 
                                            -->
                      <vue-good-table
                        title="list-order-ct"
                        mode="remote"
                        :select-options="{
                          enabled: true,
                          selectOnCheckboxOnly: true,
                          selectionText: $t('data_selected'),
                          clearSelectionText: $t('clear'),
                        }"
                        :totalRows="totalRecords"
                        :line-numbers="true"
                        :isLoading.sync="isLoading"
                        :pagination-options="{
                          enabled: false,
                        }"
                        :row-style-class="customRowClass"
                        :sort-options="{
                          enabled: false,
                        }"
                        @on-selected-rows-change="selectionChanged"
                        :rows="rows"
                        :columns="columns"
                        ref="piCreate"
                      >
                        <div slot="table-actions">
                          <button
                            class="btn btn-success btn-xs mx-2"
                            @click="addData"
                            :disabled="company == null || company == ''"
                          >
                            {{ $t("addDetail") }}
                          </button>
                          <!-- <button 
                            class="btn btn-primary btn-xs"
                            @click="addDataManual"
                          >
                            {{ $t("addDetailManual") }}
                          </button> -->
                        </div>
                        <div slot="selected-row-actions">
                          <button
                            class="btn btn-primary btn-xs mx-2"
                            @click="deleteSelected"
                            style="margin-right: 10px"
                          >
                            {{ $t("remove_txt") }}
                          </button>
                          <button
                            class="btn btn-warning btn-xs mx-2"
                            @click="duplicateDetail"
                            :disabled="rowsSelection.length > 1"
                            style="margin-right: 10px"
                          >
                            {{ $t("duplicateData") }}
                          </button>
                          <!-- <button
                            class="btn btn-success btn-xs"
                            @click="addData"
                          >
                            Add
                          </button> -->
                        </div>
                        <template slot="table-row" slot-scope="props">
                          <!-- <span v-if="props.column.field == 'entries'">
                            <a
                              style="
                                color: #ab0635;
                                text-decoration: none;
                                cursor: pointer;
                              "
                              title="Detail Load Id"
                              @click.prevent="detailPi(props.row)"
                            >
                              {{ props.row.entries }}
                            </a>
                          </span> -->
                          <span v-if="props.column.field == 'actions'">
                            <button
                              type="button"
                              class="btn btn-primary btn-xs btn-icon btn-icon"
                              style="
                                color: white;
                                text-decoration: none;
                                cursor: pointer;
                              "
                              title="Delete"
                              @click="deleteRow(props.index, props.row)"
                            >
                              <i
                                class="mdi mdi-delete"
                                style="font-size: 16px"
                              ></i>
                            </button>
                            <button
                              type="button"
                              class="btn btn-warning btn-icon mx-1 btn-xs btn-icon"
                              v-show="(forms.approve_by !== null && forms.approve_by !== '') && (props.row.proforma_invoice_detail_id !== undefined && props.row.proforma_invoice_detail_id !== null) "
                              style="
                                color: white;
                                text-decoration: none;
                                cursor: pointer;
                              "
                              title="Edit"
                              @click="editData(props.index, props.row)"
                            >
                              <i
                                class="mdi mdi-pencil"
                                style="font-size: 16px"
                              ></i>
                            </button>
                          </span>
                          <span v-else>
                            {{ props.formattedRow[props.column.field] }}
                          </span>
                        </template>
                      </vue-good-table>
                    </div>
                  </div>
                </div>
                <div class="card-footer">
                  <button
                    class="btn btn-warning text-black fw-bolder btn-icon-text"
                    @click="backForm"
                    type="button"
                  >
                    <i class="link-icon" data-feather="arrow-left"></i>
                    {{ $t("backMess") }}
                  </button>

                  &nbsp;&nbsp;&nbsp;
                  <button
                    :disabled="isLoading"
                    class="btn btn-success float-end btn-sm"
                    type="submit"
                    @click="submitData"
                  >
                    <i class="link-icon" data-feather="save"></i>
                    {{ $t("submitFormTxt") }}
                  </button>
                  <a
                    v-if="isLoading"
                    class="spinner-border text-primary float-end me-2"
                    role="status"
                  >
                    <span class="visually-hidden">Loading...</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <modal-proformaInvoiceDetail
            :showModal="showModalPI"
            :data="this.detailData"
            @closeModal="closeMyModal"
            @sendData="storeDataModal"
          >
          </modal-proformaInvoiceDetail>
          <modal-modalProformaInvoiceAdd 
            @closeModal="closeMyModal"
            :show-modal="showModalPIManual"
            :data="this.detailDataSelected"
            @sendData="storeDataModal"
          >
          </modal-modalProformaInvoiceAdd>
          <modal-ModalProformaInvoiceEdit 
            @closeModal="closeMyModal"
            :show-modal="showModalEditPi"
            :data="this.detailDataSelected"
            @sendData="updateData"
          ></modal-ModalProformaInvoiceEdit>
          
        </div>
        <!--end::content-->

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>

<script>
import sidebarComponent from "@/components/_partials/_sidebar";
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
import ModalProformaInvoiceDetail from "@/components/modal/modalProformaInvoiceDetail.vue";
import ModalProformaInvoiceAdd from "@/components/modal/modalProformaInvoiceAdd.vue";
import ModalProformaInvoiceEdit from "@/components/modal/modalProformaInvoiceEdit.vue";
import multiselect from "vue-multiselect";

export default {
  name: "proformaInvoiceCreate",
  components: {
    "sidebar-component": sidebarComponent,
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
    "modal-proformaInvoiceDetail": ModalProformaInvoiceDetail,
    "modal-modalProformaInvoiceAdd": ModalProformaInvoiceAdd,
    "modal-ModalProformaInvoiceEdit": ModalProformaInvoiceEdit,
    multiselect,
  },
  data() {
    return {
      closeBtn: true,
      isLoading: false,
      errors: [],
      proformaInvoiceNo: "",
      showModalPI: false,
      showModalPIManual: false,
      showModalEditPi: false,
      loadId: [],
      totalRecords: 0,
      forms: {},
      detailData: [],

      columns: [],
      rows: [],
      position: "up right",
      permision_role: [],
      additionalHeader: [],
      rowsSelection: [],
      selectedUniq: [],
      type: "add",
      detailDataSelected:null,

      fetchCompany: [],
      company:null,
    };
  },
  methods: {
    company_label(ev){
      return ev.code + " | "+ ev.name ;
    },
    selectedCompany(ev) {
      if(ev === null || ev === undefined || ev === "") {
        this.forms.company_id = null;
        this.forms.company_name = "";
      }else{
        this.forms.company_id = ev.company_id;
        this.forms.company_name = ev.name;
      }
    },
    asyncSearchCompany(ev) {
      const baseURI = this.$settings.endPoint + "company/select?status=active&limit=10&name=" + ev;

      return this.$http.get(baseURI).then((response) => {
        this.fetchCompany = response.data.datas.data;
      });
    },
    loadCompany() {
      const baseURI = this.$settings.endPoint + "company/select?status=active&limit=10";

      return this.$http.get(baseURI).then((response) => {
        this.fetchCompany = response.data.datas.data;
      });
    },

    removeReadonly() {
      this.$nextTick(() => {
        const input = this.$refs.inputCompany.$el.querySelector(
          ".multiselect__input"
        );
        if (input && input.hasAttribute("readonly")) {
          input.removeAttribute("readonly");
        }
      });
    },
    deleteRow(index){
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourDataDelete"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          let currentRow = [...this.rows];
          console.log(currentRow)
          currentRow.splice(index,1);
          this.rows = currentRow;
        }
      });
    },
    selectionChanged(ev) {
      this.rowsSelection = [];
      this.selectedUniq = [];
      this.rowsSelection = ev.selectedRows;

      this.rowsSelection.forEach((item) => {
        this.selectedUniq.push(item.load_id + "-" + item.shipment_numbers+"-"+item.originalIndex);
      });
    },
    setColumn() {
      this.columns = [
        {
          label:"Action",
          field:"actions",
          width:"100px"
        },
        {
          label: "Sold to Party Name",
          field: "sold_to_party",
        },
        {
          label: "Load Id",
          field: "load_id",
        },
        {
          label: "Nopol",
          field: "vehicle_no",
        },
        {
          label: "Equipment Description",
          field: "equipment_description",
        },
        {
          label: "Loading Date",
          field: "loading_date",
        },
        {
          label: "Unloading date",
          field: "unloading_date",
        },
        {
          label: "Origin",
          field: "origin",
        },
        {
          label: "Destination",
          field: "destination",
        },
        {
          label: "Delivery Order",
          field: "delivery_order",
        },
        {
          label: "Shipment Numbers",
          field: "shipment_numbers",
        },
        {
          label: "UOM",
          field: "uom",
        },
        {
          label: "Qty / Ton",
          field: "qty",
        },
        {
          label: "Driver ID",
          field: "driver_id",
        },
        {
          label: "Driver Name",
          field: "driver_name",
        },
         {
          label: "Ship To",
          field: "ship_to",
        },
        {
          label: "Billable Rate",
          field: "billable_rate",
          formatFn: this.formatCurrency,
        },
      ];
    },
    submitData() {
      if (this.type == "edit") {
        this.update();
      }

      if (this.type == "add") {
        this.add();
      }
    },

    update() {
      this.isLoading = true;
      const baseURI =
        this.$settings.endPointProformaInvoice +
        "v1/proforma-invoice/update/" +
        this.forms.proforma_invoice_header_id;
      this.$http
        .patch(baseURI, this.rows, { timeout: 10000 })
        .then((response) => {
          this.loading();
          if (response.data.status === 200) {
            this.loadItems();
            this.success("Success");

            const error = response.data.errors;
            if(error !== null && error.length > 0){
              let errStr = error.toString();
              errStr.replaceAll(",","<br>");
              this.showCustomError(errStr);             
            }
          } else {
            this.isLoading = false;
            this.errors = response.data.errors;
            this.resultError(response.data.errors);
          }
        })
        .catch((error) => {
          this.loading();
          this.isLoading = false;
          if (error.code == "ECONNABORTED") {
            this.error("Please Check Your Internet Connection");
          }

          if (error.response) {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors;
              this.resultError(error.response.data.errors);
            } else if (error.response.status === 500) {
              this.$router.push("/server-error");
            } else {
              this.$router.push("/page-not-found");
            }
          }
        });
    },
    showCustomError(msg){
      console.log(msg);
      this.$swal({
        title: "Error",
        html:msg,
        icon: "error",
      });
    },
    add() {
      this.isLoading = true;
      const baseURI =
        this.$settings.endPointProformaInvoice + "v1/proforma-invoice/create";
        let send = {
          company_id: this.forms.company_id,
          company_name: this.forms.company_name,
          details: this.rows,
        };
      this.$http
        .post(baseURI, send, { timeout: 10000 })
        .then((response) => {
          this.loading();
          if (response.data.status === 200) {
            // this.forms = response.data.datas;
            // this.loadItems();
            // this.type = 'edit';
            this.success("Success");

            var params = this.$onRandom(
              response.data.datas.proforma_invoice_header_id
            );
            // this.$router.push("/proforma-invoice/add/" + params);
            const error = response.data.errors;
            if(error !== null && error.length > 0){
              let errStr = error.toString();
              errStr.replaceAll(",","<br>");
              localStorage.setItem('customErrorPI',errStr);              
            }
            
            window.location.href = "/proforma-invoice/add/" + params;
          } else {
            this.isLoading = false;
            this.errors = response.data.errors;
            this.resultError(response.data.errors);
          }
        })
        .catch((error) => {
          this.loading();
          this.isLoading = false;
          if (error.code == "ECONNABORTED") {
            this.error("Please Check Your Internet Connection");
          }

          if (error.response) {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors;
              this.resultError(error.response.data.errors);
            } else if (error.response.status === 500) {
              this.$router.push("/server-error");
            } else {
              this.$router.push("/page-not-found");
            }
          }
        });
    },

    formatCurrency(val) {
      return parseInt(val).toLocaleString();
    },
    detailPi(data) {
      console.log(data);
    },
    deleteData(index, data) {
      console.log(data, index);
    },
    deleteSelected() {
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourDataDelete"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          let currentRow = [...this.rows];
          this.rows = currentRow.filter((item,index) => {
            let concat = item.load_id + "-" + item.shipment_numbers+"-"+index;
            if (!this.selectedUniq.includes(concat)) {
              return true;
            }
          });
        }
      });
    },
    editData(index, data) {
      data['index'] = index;
      this.detailDataSelected = data;    
      this.showModalEditPi = true;
    },
    addData() {
      this.detailData["method"] = "create";
      this.detailData["data"] = this.forms;
      this.showModalPI = true;
    },
    duplicateDetail() {
      let rowsSelected= [...this.rowsSelection];

      this.detailDataSelected = rowsSelected[0];    
      this.showModalPIManual = true;
    },
    addDataManual() {
      // this.detailData["method"] = "create";
      // this.detailData["data"] = this.forms;
      this.showModalPIManual = true;
    },
    storeDataModal(data, header) {
      this.fade(true);
      if (data !== null || data.length > 0) {
        this.setColumn();
        data.forEach((item) => {
          this.rows.push(item);
        });
        this.showModalPI = false;
        this.showModalPIManual = false;
        this.additionalHeader = this.additionalHeader.concat(header);
        this.additionalHeader = [...new Set(this.additionalHeader)];

        this.additionalHeader.forEach((val) => {
          let field = val;
          let text_label = val
            .replaceAll("_", " ")
            .split(" ")
            .map((w) => w.substring(0, 1).toUpperCase() + w.substring(1))
            .join(" ");
          this.columns.push({
            label: text_label,
            field: field,
            formatFn: this.formatCurrency,
          });
        });

        this.columns.push({
          label: "Total",
          field: "total",
          formatFn: this.formatCurrency,
        });
      }
      this.$refs['piCreate'].unselectAllInternal();
      this.loading();
    },
    updateData(){
        this.showModalPI = false;
        this.showModalPIManual = false;
        this.showModalEditPi = false;
      //  this.fade(true);
      this.loadItems();

      // if (data !== null || data.length > 0) {
      //   this.setColumn();
      //   // data.forEach((item) => {
      //   //   this.rows.push(item);
      //   // });
      //   this.rows.splice(index,1,data);

      //   this.showModalPI = false;
      //   this.showModalPIManual = false;
      //   this.showModalEditPi = false;

      //   this.additionalHeader = this.additionalHeader.concat(header);
      //   this.additionalHeader = [...new Set(this.additionalHeader)];

      //   this.additionalHeader.forEach((val) => {
      //     let field = val;
      //     let text_label = val
      //       .replaceAll("_", " ")
      //       .split(" ")
      //       .map((w) => w.substring(0, 1).toUpperCase() + w.substring(1))
      //       .join(" ");
      //     this.columns.push({
      //       label: text_label,
      //       field: field,
      //       formatFn: this.formatCurrency,
      //     });
      //   });

      //   this.columns.push({
      //     label: "Total",
      //     field: "total",
      //     formatFn: this.formatCurrency,
      //   });
      // }
    },
    resetForm() {
      console.log("test");
    },
    recalculate() {
      this.$swal({
        title: this.$t("areYouSure"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          this.$swal({
            icon: "warning",
            title: "Please Wait",
            text: "Don't Close This Page !!!",
            timerProgressBar: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            showCancelButton: false, // There won't be any cancel button
            showConfirmButton: false, // There won't be any confirm button
            didOpen: async () => {
              this.$swal.showLoading();

              const baseURI =
                this.$settings.endPointProformaInvoice +
                "v1/proforma-invoice/recalculate/" +
                this.forms.proforma_invoice_header_id;
              await this.$http.post(baseURI).then(() => {
                this.loadItems();
                this.$swal.close();
              });
            },
          });
        }
      });
    },
    backForm() {
      this.$router.push("/proforma-invoice/created");
    },
    closeMyModal() {
      this.showModalPI = false;
      this.showModalEditPi = false;
      this.showModalPIManual = false;
    },
    fetchIt() {
      const userDatas = this.$getUserInfo();
      this.detailUser = userDatas.sub;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function (permision) {
        if (permision.permission.controller == "ProformaInvoiceController") {
          rolePermision = permision;
        }
      });

      if (!rolePermision.method_create) {
        this.$router.push("/authorized-error");
      }
      this.permision_role = rolePermision;
    },
    loadItems() {
      var params = this.$onBehind(this.$route.params.id);
      this.loadData(params[0]);
    },
    loadData(id) {
      const baseURI =
        this.$settings.endPointProformaInvoice +
        "v1/proforma-invoice/detail/" +
        id+"?sort_field=type&sort_type=ASC";
      return this.$http.get(baseURI).then((response) => {
        let res = response.data.datas;
        this.setColumn();
        let additionalHeader = res.additionalHeader;
        this.additionalHeader = additionalHeader;
        additionalHeader.forEach((val) => {
          let field = val;
          let text_label = val
            .replaceAll("_", " ")
            .split(" ")
            .map((w) => w.substring(0, 1).toUpperCase() + w.substring(1))
            .join(" ");
          this.columns.push({
            label: text_label,
            field: field,
            formatFn: this.formatCurrency,
          });
        });

        this.columns.push({
          label: "Total",
          field: "total",
          formatFn: this.formatCurrency,
        });

        this.forms = res;
        this.company = res.company;
        this.rows = res.details;
      });
    },
    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "success",
        title: kata,
      });
    },
    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.isLoading = false;
      }, 1000); // hide the message after 3 seconds
    },
    customRowClass(row){
      if(row.status_flow !== "MANUAL"){
        return "custom-bg-green"
      }
    }
  },
  created() {
    this.setColumn();
  },
  mounted() {
    this.fetchIt();
    this.loadCompany();
    var params = this.$onBehind(this.$route.params.id);
    if (params.length > 0) {
      this.loadData(params[0]);
      this.type = "edit";
    }

    let checkErrorAdd = localStorage.getItem('customErrorPI');
    if(checkErrorAdd !== null){
      this.showCustomError(checkErrorAdd);
      localStorage.removeItem('customErrorPI')
    }
  },
  computed: {
    totals() {
      var total = 0;
      this.rows.forEach((value) => {
        total += parseFloat(value.total);
      });
      return total;
    },
    totalLoad() {
      let distinct = [
        ...new Set(
          this.rows.map((item) => {
            return item.load_id;
          })
        ),
      ];
      return distinct.length;
    },
  },
};
</script>

<style>
.custom-bg-green{
  background-color: rgba(0, 153, 51, 0.5);
  color:white;
}

</style>
